import React, { useState } from 'react';
import Footer from './Footer';
import SEOHead from '../seo/SEOHead';
import { PAGE_SEO } from '../seo/seoConfig';

import image1 from '../assets/png-pipeline.jpeg';
import image2 from '../assets/A-flame-that-care.jpeg'
import director from '../assets/Director.jpeg';
import custom from '../assets/custom5.jpeg';
import what from '../assets/What-we-do.jpeg';
import slide2 from '../assets/Home-Page-Banner-2.jpeg';
import slide3 from '../assets/Home-Page-Banner-3.jpeg';
import flame2 from '../assets/custom3.jpeg';
import flame3 from '../assets/custom2.jpeg';
import flame4 from '../assets/custom1.jpeg';


const BehindTheLens = () => {
  const [activeFilter, setActiveFilter] = useState('Inside The Workshop');
  const [visibleImages, setVisibleImages] = useState(8);

  // Mock industrial/manufacturing images data organized by categories
  const allImages = {
    'Inside The Workshop': [
      {
        id: 1,
        src: image1,
        alt: 'Industrial workers in safety gear',
      },
      {
        id: 2,
        src: image2,
        alt: 'Factory assembly line'
      },
      {
        id: 3,
        src: director,
        alt: 'Quality control inspection'
      },
      {
        id: 4,
        src: custom,
        alt: 'Workers reviewing blueprints'
      },
      {
        id: 5,
        src: what,
        alt: 'Warehouse operations'
      },
      {
        id: 6,
        src: slide2,
        alt: 'Factory machinery'
      },
      {
        id: 7,
        src: slide3,
        alt: 'Manufacturing equipment'
      },
      {
        id: 8,
        src: flame2,
        alt: 'Large manufacturing floor'
      },
      {
        id: 9,
        src: flame3,
        alt: 'Additional workshop view'
      },
      {
        id: 10,
        src: flame4,
        alt: 'More workshop content'
      }
    ],
    'Engineering In Action': [
      {
        id: 7,
        src: 'https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=600&h=400&fit=crop',
        alt: 'Engineering team at work'
      },
      {
        id: 8,
        src: 'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=300&h=200&fit=crop',
        alt: 'Manufacturing process'
      },
      {
        id: 9,
        src: 'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=300&h=200&fit=crop',
        alt: 'Technical documentation'
      },
      {
        id: 10,
        src: 'https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=300&h=200&fit=crop',
        alt: 'Equipment testing'
      },
      {
        id: 11,
        src: 'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=300&h=200&fit=crop',
        alt: 'Engineering design'
      },
      {
        id: 12,
        src: 'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=300&h=200&fit=crop',
        alt: 'Technical analysis'
      },
      {
        id: 13,
        src: 'https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=300&h=200&fit=crop',
        alt: 'Engineering tools'
      },
      {
        id: 14,
        src: 'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=600&h=300&fit=crop',
        alt: 'Engineering overview'
      }
    ],
    'Living The Product': [
      {
        id: 11,
        src: 'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=600&h=400&fit=crop',
        alt: 'Product in use'
      },
      {
        id: 12,
        src: 'https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=600&h=400&fit=crop',
        alt: 'End user experience'
      },
      {
        id: 13,
        src: 'https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=300&h=200&fit=crop',
        alt: 'Product lifestyle'
      },
      {
        id: 14,
        src: 'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=300&h=200&fit=crop',
        alt: 'Real world application'
      },
      {
        id: 15,
        src: 'https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=600&h=400&fit=crop',
        alt: 'Customer satisfaction'
      },
      {
        id: 16,
        src: 'https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=300&h=200&fit=crop',
        alt: 'Product quality'
      },
      {
        id: 17,
        src: 'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=300&h=200&fit=crop',
        alt: 'User testimonial'
      },
      {
        id: 18,
        src: 'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=300&h=200&fit=crop',
        alt: 'Product showcase'
      }
    ],
    'Exhibit Highlights': [
      {
        id: 16,
        src: 'https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=600&h=400&fit=crop',
        alt: 'Exhibition display'
      },
      {
        id: 17,
        src: 'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=300&h=200&fit=crop',
        alt: 'Trade show booth'
      },
      {
        id: 18,
        src: 'https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=600&h=400&fit=crop',
        alt: 'Product demonstration'
      },
      {
        id: 19,
        src: 'https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=300&h=200&fit=crop',
        alt: 'Exhibition highlights'
      },
      {
        id: 20,
        src: 'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=300&h=200&fit=crop',
        alt: 'Industry showcase'
      },
      {
        id: 21,
        src: 'https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=600&h=400&fit=crop',
        alt: 'Exhibition technology'
      },
      {
        id: 22,
        src: 'https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=300&h=200&fit=crop',
        alt: 'Trade show innovation'
      },
      {
        id: 23,
        src: 'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=600&h=300&fit=crop',
        alt: 'Exhibition overview'
      }
    ]
  };

  const currentImages = allImages[activeFilter] || [];
  const displayedImages = currentImages.slice(0, visibleImages);

  const handleImageClick = (index) => {
    const modal = document.getElementById('imageModal');
    const modalImg = document.getElementById('modalImage');
    const caption = document.getElementById('caption');
    
    modal.style.display = 'block';
    modalImg.src = displayedImages[index].src;
    caption.innerHTML = displayedImages[index].alt;
  };

  const handleFilterChange = (filter) => {
    setActiveFilter(filter);
    setVisibleImages(8); // Reset to 8 images when changing filters
  };

  const handleLoadMore = () => {
    setVisibleImages(prev => Math.min(prev + 8, currentImages.length));
  };

  const closeModal = () => {
    const modal = document.getElementById('imageModal');
    modal.style.display = 'none';
  };

  return (
    <>
    <SEOHead
      title={PAGE_SEO.gallery.title}
      description={PAGE_SEO.gallery.description}
      keywords={PAGE_SEO.gallery.keywords}
      canonical={PAGE_SEO.gallery.canonical}
      ogImage={PAGE_SEO.gallery.ogImage}
    />
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#ffffff',
      fontFamily: 'Poppins, sans-serif'
    }}>
      {/* Header */}
      <header style={{
        textAlign: 'center',
        padding: '48px 20px 32px',
        paddingTop:'0px',
        backgroundColor: 'white'
      }}>
        <h1 style={{
          fontSize: 'clamp(32px, 5vw, 48px)',
          fontWeight: '500',
          color: '#333',
          marginBottom: '8px',
          letterSpacing: '2px'
        }}>
          Behind The Lens
        </h1>
        <p style={{
          color: '#F58220',
          fontSize: 'clamp(14px, 2vw, 16px)',
          fontWeight: '500',
          margin: '0',
          padding: '0 20px'
        }}>
         Where innovation meets craftsmanship — inside the RealFlame journey.
        </p>
      </header>

      {/* Navigation */}
      <nav style={{
        backgroundColor: 'white',
        borderBottom: '1px solid #eee',
        padding: '0 20px',
        overflowX: 'auto'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'center',
          gap: 'clamp(16px, 4vw, 48px)',
          flexWrap: 'wrap',
          minWidth: 'fit-content'
        }}>
          {['Inside The Workshop', 'Engineering In Action', 'Living The Product', 'Exhibit Highlights'].map((item, index) => (
            <button
              key={index}
              onClick={() => handleFilterChange(item)}
              style={{
                background: 'none',
                border: 'none',
                padding: '16px 4px',
                fontSize: 'clamp(12px, 1.5vw, 14px)',
                color: activeFilter === item ? '#F58220' : '#666',
                fontWeight: '500',
                cursor: 'pointer',
                borderBottom: activeFilter === item ? '2px solid #F58220' : 'none',
                transition: 'color 0.3s ease',
                whiteSpace: 'nowrap'
              }}
            >
              {item}
            </button>
          ))}
        </div>
      </nav>

      {/* Gallery */}
      <main style={{
        padding: 'clamp(24px, 5vw, 48px) clamp(12px, 3vw, 24px)',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '12px',
          gridAutoFlow: 'dense'
        }}>
          {displayedImages.map((image, index) => (
            <div
              key={image.id}
              onClick={() => handleImageClick(index)}
              style={{
                cursor: 'pointer',
                overflow: 'hidden',
                borderRadius: '8px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                gridColumn: index === 0 || index === 7 ? 'span 2' : 'span 1',
                aspectRatio: index === 0 || index === 7 ? '2/1' : '1/1'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
              }}
            >
              <img
                src={image.src}
                alt={image.alt}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  display: 'block'
                }}
              />
            </div>
          ))}
        </div>

        {/* Load More Button */}
        {visibleImages < currentImages.length && (
          <div style={{
            textAlign: 'center',
            marginTop: 'clamp(32px, 5vw, 48px)'
          }}>
            <button 
              onClick={handleLoadMore}
              style={{
                backgroundColor: '#F58220',
                color: 'white',
                border: 'none',
                padding: '12px 32px',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer',
                borderRadius: '4px',
                transition: 'background-color 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#e6741c'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#F58220'}
            >
              Load More →
            </button>
          </div>
        )}
      </main>

      {/* Simple Modal for image viewing */}
      <div id="imageModal" style={{
        display: 'none',
        position: 'fixed',
        zIndex: 1000,
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.9)',
        cursor: 'pointer'
      }} onClick={closeModal}>
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          maxWidth: '90%',
          maxHeight: '90%'
        }}>
          <img id="modalImage" style={{
            width: '100%',
            height: 'auto',
            maxHeight: '90vh',
            objectFit: 'contain'
          }} alt="" />
          <div id="caption" style={{
            textAlign: 'center',
            color: 'white',
            padding: '16px',
            fontSize: '16px'
          }}></div>
        </div>
        <span style={{
          position: 'absolute',
          top: '24px',
          right: '32px',
          color: 'white',
          fontSize: '32px',
          fontWeight: 'bold',
          cursor: 'pointer'
        }}>×</span>
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default BehindTheLens;